import { IOriginDestination } from "@common/models";
import Translate from "@service/Translate";
import { FC, Fragment } from "react";
import ItineraryPanel from "./ItineraryPanel";

interface IFareRulesProps {
    originDestinations: IOriginDestination[];
}

const FareRules: FC<IFareRulesProps> = (props) => {
    const { tr } = Translate;
    let fareRuleslenght = 0;
    props.originDestinations.forEach(od => od.fareRules?.forEach(fr => fareRuleslenght++));
    return (
        fareRuleslenght ? <div className="itinerary-fare-rules">
            <ItineraryPanel title={tr("fare_rules")} >
                <div className={`row flex fare-rules-body${fareRuleslenght % 2 !== 0 ? " full-width" : ""}`}>
                    {
                        props.originDestinations.map((od, index) =>
                            <Fragment key={index}>
                                {
                                    od.fareRules?.map((fr, index) =>
                                        <div key={index} className="col-1-auto fare-rules-item">
                                            <div className="fare-rule-item-title">{fr.segmentCode}</div>
                                            <div className="fare-rule-item-desc en" dangerouslySetInnerHTML={{ __html: fr.comment || "" }} />
                                        </div>
                                    )
                                }
                            </Fragment>
                        )
                    }
                </div>
            </ItineraryPanel>
        </div>
            : null
    )
}

export default FareRules;